import { render } from "./ResourcesLanguageModal.vue?vue&type=template&id=ef5871a8"
import script from "./ResourcesLanguageModal.vue?vue&type=script&lang=js"
export * from "./ResourcesLanguageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__